import React from 'react';

import { IIconProps, TIconType } from '../interface';

const WarningIconActive: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			viewBox='0 0 24 24'
			{...props?.innerSvgProps}
		>
			<path
				d='M10.706 3.75 2.456 18a1.5 1.5 0 0 0 1.294 2.25h16.5A1.5 1.5 0 0 0 21.544 18l-8.25-14.25a1.49 1.49 0 0 0-2.588 0v0Z'
				fill='#fff'
				stroke='#fff'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12 9.75v3.75'
				stroke='#4D4DB3'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12.25 16.875a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z'
				fill='#4D4DB3'
				stroke='#4D4DB3'
			/>
		</svg>
	);
};

export default WarningIconActive;
